import bankUpdate from './bankUpdate';
import companyInfo from './companyInfo';
import descUpdate from './descUpdate';
import detailUpdate from './detailUpdate';
import uploadToken from './uploadToken';
import imageUpdate from './imageUpdate';
import countryInfo from './countryInfo';
import countryStateCities from './countryStateCities';
import countryStates from './countryStates';
import elegantGetMainImage from './elegantGetMainImage';
import elegantImagesDelete from './elegantImagesDelete';
import elegantImagesGet from './elegantImagesGet';
import elegantImagesUpload from './elegantImagesUpload';
import elegantSetMainImage from './elegantSetMainImage';
import loggingUpload from './loggingUpload';
import outsidInfo from './outsidInfo';
import createdid from './createdid';
import getdidlist from './getdidlist';
import setdidDefault from './setdidDefault';
import ResubmitDid from './resubmitDid';
export default {
    bankUpdate,
    companyInfo,
    descUpdate,
    detailUpdate,
    uploadToken,
    imageUpdate,
    countryInfo,
    countryStateCities,
    countryStates,
    elegantGetMainImage,
    elegantImagesDelete,
    elegantImagesGet,
    elegantSetMainImage,
    elegantImagesUpload,
    loggingUpload,
    outsidInfo,
    createdid,
    getdidlist,
    setdidDefault,
    ResubmitDid
};



// WEBPACK FOOTER //
// ./src/api/systemManage/companyInfo/index.ts